import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=915d7a8a&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=915d7a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915d7a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915d7a8a')) {
      api.createRecord('915d7a8a', component.options)
    } else {
      api.reload('915d7a8a', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=915d7a8a&scoped=true&", function () {
      api.rerender('915d7a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/components/SearchBar.vue"
export default component.exports